import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { EventPreviewBigComponent } from '@modules/calendar-app/components/event-preview/event-preview-big.component';
import { type CalendarEvent } from '@modules/calendar-app/types/calendar-event';
import { DynamicPanelModule } from '@modules/dynamic-panel/dynamic-panel.module';
import { ClickDirective } from '@modules/utils/directives/click/click.directive';

@Component({
  selector: 'stch-big-events-preview-list',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DynamicPanelModule, EventPreviewBigComponent, ClickDirective],
  template: `<div class="flex flex-col gap-6">
    @for (event of events(); track $index) {
      <stch-event-preview-big
        [event]="event"
        (appClick)="eventClicked.emit(event)"
        (appDblClick)="eventDblClicked.emit(event)"
        [appClickStopPropagation]="true"
      />
    }
  </div>`,
})
export class BigEventsPreviewListComponent {
  public readonly events = input.required<CalendarEvent[]>();
  protected readonly eventClicked = output<CalendarEvent>();
  protected readonly eventDblClicked = output<CalendarEvent>();
}
